var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 0.666016C1.79467 0.666016 0 2.47313 0 4.6949C0 7.85179 3.624 11.1114 3.77822 11.2482C3.83918 11.3028 3.9181 11.333 3.99992 11.3331C4.08173 11.3332 4.16071 11.3031 4.22178 11.2487C4.376 11.1114 8 7.85179 8 4.6949C8 2.47313 6.20533 0.666016 4 0.666016ZM4 6.88824C2.77467 6.88824 1.77778 5.89135 1.77778 4.66602C1.77778 3.44068 2.77467 2.44379 4 2.44379C5.22533 2.44379 6.22222 3.44068 6.22222 4.66602C6.22222 5.89135 5.22533 6.88824 4 6.88824Z",
    fill: "#0195D3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserLocation);
export default __webpack_public_path__ + "static/media/user-location.ffbb61823518bf4479247eaa7a08774b.svg";
export { ForwardRef as ReactComponent };